import React from 'react';

import PropTypes from 'prop-types';

import Loader from 'components/common/Loader';

const EachSideContentHandlerDashboard = props => {
  const { children, value, index } = props;

  return (
    <div
      role="tabpanel"
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      style={{ width: '100%' }}
    >
      {value === index && (
        <div p={3}>
          {children?.props?.children?.length > 0 ? (
            <div>{children}</div>
          ) : (
            <Loader />
          )}
        </div>
      )}
    </div>
  );
};
EachSideContentHandlerDashboard.propTypes = {
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
  children: PropTypes.element.isRequired,
};
export default EachSideContentHandlerDashboard;
